import { render, staticRenderFns } from "./FabricStage.vue?vue&type=template&id=c4936906"
import script from "./FabricStage.vue?vue&type=script&lang=js"
export * from "./FabricStage.vue?vue&type=script&lang=js"
import style0 from "./FabricStage.vue?vue&type=style&index=0&id=c4936906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports